module.exports = __webpack_public_path__ + "img/Loading_r_10.9a69e3d2.png";